/** Utility to shuffle an array in-place */
export function shuffleArray(arr) {
    const cloned = [...arr];
    for (let i = cloned.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [cloned[i], cloned[j]] = [cloned[j], cloned[i]];
    }
    return cloned;
  }